import React from 'react';
import './contact.css';
import contact from './images/bg-title-page-02.jpg';
import locatio from './images/icons/map-icon.png';
import call from './images/icons/phone-icon.png';
import clock from './images/icons/clock-icon.png';

const Contact = () => {
  return (
    <div className='contact'>
      <section className='hero' style={{ backgroundImage: `url(${contact})` }}>
        <div className="hero-content">
          <h1>Contact</h1>
        </div>
      </section>
     <div style={{ width: "70%", height: "400px", marginTop: "5%" ,marginLeft: "15%", marginBottom: "5%"}}>
      <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2933.248672289951!2d21.16283401569701!3d42.66291327916752!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13549e1b08bdb1a7%3A0x94ebd55b8f69c792!2sPrishtina!5e0!3m2!1sen!2s!4v1698595475231!5m2!1sen!2s"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>
    </div>
<div className="method">
  <center><h1>SEND US A MESSAGE</h1></center>
  <div className="grid">
    <div className="input-typeM">
      <p>
        Name<br />
        <input type="text" placeholder="Name" required className="inputM" />
      </p>
    </div>

    <div className="input-typeM">
      <p>
        Email<br />
        <input type="email" placeholder="Email" required className="inputM" />
      </p>
    </div>

    <div className="input-typeM">
      <p>
        Phone<br />
        <input type="text" placeholder="Phone" required className="inputM"  />
      </p>
    </div>
    <div className="input-typeM full-width">
      <p>
        Message<br /><br />
        <textarea required
          placeholder="Message"
          className="inputMq"
        ></textarea>
      </p>
      <button type="submit" className="btn">Submit</button>
    </div>
  </div>
</div>
      <div className='LCO'>
        <div>
          <h1>Location <img src={locatio} style={{height: "2%"}} /> </h1>
          <p>8th floor, 379 Hudson St,<br /> New York, NY 10018</p>
        </div>
        <div>
          <h1>Call Us <img src={call} style={{height: "2%"}} /> </h1>
          <p>(+1) 96 716 6879</p>
        </div>
        <div>
          <h1>Opening Hours <img src={clock} style={{height: "2%"}} /> </h1>
          <p>09:30 AM – 11:00 PM <br />Every Day</p>
        </div>        
      </div>
   </div>
  )
}

export default Contact